import React from 'react';
import { IconRefresh } from './Icons';
import './VectorResultsLoadingState.css';
import { getResultsNavLabel } from '../utils/activeEntity';

/**
 * Loading UI for Vector Results (dashboard + standalone Results page).
 */
export function VectorResultsLoadingState({
  variant = 'dashboard',
  isCurrent = true,
  isSummary = false,
  sheetLabel = '',
}) {
  const isDashboard = variant === 'dashboard';

  const title = !isDashboard
    ? 'Loading current results'
    : isCurrent
      ? 'Loading current week'
      : isSummary
        ? 'Loading comparison'
        : 'Loading strategy data';

  const subtitle = !isDashboard
    ? `Fetching rows from the ${getResultsNavLabel()} spreadsheet…`
    : isCurrent
      ? `Fetching strategy rows from the ${getResultsNavLabel()} spreadsheet…`
      : sheetLabel
        ? `Preparing ${sheetLabel}…`
        : 'Preparing sheet…';

  const rootClass =
    'vrl' +
    (isDashboard ? ' vrl--dashboard results-dash-card' : ' vrl--standalone');

  return (
    <div className={rootClass} role="status" aria-live="polite">
      <div className="vrl-header">
        <span className="vrl-spin" aria-hidden="true">
          <IconRefresh size={22} color="rgba(129, 140, 248, 0.95)" />
        </span>
        <div>
          <p className="vrl-title">{title}</p>
          <p className="vrl-sub">{subtitle}</p>
        </div>
      </div>

      {!isDashboard && (
        <div className="vrl-table-skeleton" aria-hidden="true">
          <div className="vrl-table-head">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <span key={i} className="vrl-shimmer vrl-shimmer-chip" />
            ))}
          </div>
          {[0, 1, 2, 3, 4, 5, 6].map((r) => (
            <div key={r} className="vrl-table-row">
              {[0, 1, 2, 3, 4, 5].map((c) => (
                <span
                  key={c}
                  className="vrl-shimmer vrl-shimmer-cell"
                  style={{ opacity: c === 0 ? 1 : 0.45 + (c % 4) * 0.1 }}
                />
              ))}
            </div>
          ))}
        </div>
      )}

      {isDashboard && isCurrent && (
        <>
          <div className="vrl-summary">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="vrl-summary-cell">
                <span className="vrl-shimmer vrl-line vrl-line--title" />
                <span className="vrl-shimmer vrl-line vrl-line--value" />
                <span className="vrl-shimmer vrl-line vrl-line--sm" />
              </div>
            ))}
          </div>
          <div className="vrl-cards">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="vrl-card">
                <div className="vrl-card-top">
                  <span className="vrl-shimmer vrl-line vrl-line--name" />
                  <span className="vrl-shimmer vrl-pill" />
                  <span className="vrl-shimmer vrl-line vrl-line--amount" />
                </div>
                <div className="vrl-chips">
                  {[0, 1, 2, 3, 4].map((j) => (
                    <span key={j} className="vrl-shimmer vrl-chip" />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {isDashboard && !isCurrent && (
        <div className="vrl-compact" aria-hidden="true">
          <span className="vrl-shimmer vrl-line vrl-line--wide" />
          <span className="vrl-shimmer vrl-line vrl-line--wide vrl-line--short" />
          <span className="vrl-shimmer vrl-line vrl-line--wide" />
        </div>
      )}
    </div>
  );
}
